import Vue from 'vue/dist/vue.esm.js';

Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.config.silent = true;

export default Vue;